import { useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { axInst } from "../../../Components/Login/Service";
import { Loader } from "rsuite";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import wrench from "../../../Artifacts/SalesSucessCenter/screwdriver-wrench.png";
import raised from "../../../Artifacts/SalesSucessCenter/raised.png";
import approved from "../../../Artifacts/SalesSucessCenter/approved.png";
import truck from "../../../Artifacts/SalesSucessCenter/Totalvehicle.svg";
// import mop_growth from "../../../Artifacts/SalesSucessCenter/MOP_growth.png";
import ModalMuiTable from "../../../Components/Modals/ModalMuiTable.jsx";

const dse_with_low_pipelineApi = async (body) => {
  const res = await axInst.post(
    "dealer-sales-success-centre/dse_with_low_pipeline",
    body
  );
  return res.data;
};

const nfa_api = async (body) => {
  const response = await axInst.post(
    "dealer-sales-success-centre/nfa_data",
    body
  );
  return response.data;
};

// const growth_api = async (body) => {
//   const response = await axInst.post(
//     "dealer-sales-success-centre/total_mop_growth",
//     body
//   );
//   return response.data;
// };

const DseLowPipeline = () => {
  const { data, submitted } = useSelector((e) => e.filtersSalesSuccessCenter);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalApi, setModalApi] = useState("");
  const [modalHeading, setModalHeading] = useState("");

  const {
    data: DseLowPipelineData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["dse", submitted],
    queryFn: () => dse_with_low_pipelineApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  const { data: NFAData } = useQuery({
    queryKey: ["nfa", submitted],
    queryFn: () => nfa_api(data),
    cacheTime: 0,
    staleTime: 0,
  });

  // const { data: GrowthData } = useQuery({
  //   queryKey: ["growth", submitted],
  //   queryFn: () => growth_api(data),
  //   cacheTime: 0,
  //   staleTime: 0,
  // });

  const handleOpenModal = (api, heading) => {
    setModalApi(api);
    setModalHeading(heading);
    setIsModalOpen(true);
  };

  return (
    <div className="relative">
      <WaterMark />
      {isFetching ? (
        <div className="flex items-center justify-center h-40">
          <Loader />
        </div>
      ) : isError || !DseLowPipelineData ? (
        <div className="flex items-center justify-center h-40">
          <p>Data not available</p>
        </div>
      ) : (
        <>
          <div className="bg-white p-2 rounded-xl shadow">
            <div className="pb-1 text-base font-semibold text-[#4c4c4c]">
              DSE With Low Pipeline
            </div>
            <div className="grid grid-cols-2 gap-2 text-center text-sm font-semibold text-gray-700 ">
              <div className="bg-gray-100 p-2 rounded-lg flex  items-center">
                <img src={wrench} alt="Wrench Icon" className="w-6 h-6" />
                <div>
                  <div
                    className="text-xs text-[#667085] underline w-24 pb-1 cursor-pointer "
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/dse_non_performer_report",
                        "DSE with no CO in last 2 days"
                      )
                    }
                  >
                    # DSE with no CO in last 2 days
                  </div>
                  <div className="text-black text-sm">
                    {DseLowPipelineData.DSE_with_no_C0_in_last_2_days}
                  </div>
                  <div
                    className="text-xs text-[#667085] underline w-24 pb-1  cursor-pointer"
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/dse_performer_report",
                        "DSE with C0"
                      )
                    }
                  >
                    # DSE with C0
                  </div>
                  <div className="text-black text-sm">
                    {DseLowPipelineData.DSE_with_C0}
                  </div>
                </div>
              </div>

              <div className="bg-gray-100 p-2 rounded-lg flex gap-6 items-center">
                <img src={wrench} alt="Wrench Icon" className="w-6 h-6" />
                <div>
                  <div
                    className="text-xs text-[#667085] mb-2 underline cursor-pointer pb-1 "
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/zero_tqp_report",
                        "Zero TQP"
                      )
                    }
                  >
                    0 TQP
                  </div>
                  <div className="text-black text-sm mb-1">
                    {DseLowPipelineData.Zero_TQP}
                  </div>
                  <div
                    className="text-xs text-[#667085]  underline cursor-pointer "
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/non_zero_tqp_report",
                        "TQP"
                      )
                    }
                  >
                    TQP
                  </div>
                  <div className="text-black text-sm mt-1">
                    {DseLowPipelineData.TQP}
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-blue-50 border-dashed border-2 p-1 rounded-lg flex gap-24 items-center mt-1">
              <div className="flex items-center gap-6">
                <img src={truck} alt="Truck Icon" className="w-8 h-7" />
                <div className="text-sm font-semibold">Total DSEs</div>
              </div>
              <div className="text-black text-sm font-semibold">
                {DseLowPipelineData.Total_DSEs}
              </div>
            </div>
          </div>
          <div className="bg-white p-2 rounded-xl mt-1 shadow">
            {/* <div className="font-semibold text-gray-800 ">NFA</div> */}
            <div className="grid grid-cols-2 gap-2 my-[4px] border-b border-gray-200 ">
              <div className="flex items-center gap-3 p-1 pt-0  text-sm font-semibold text-gray-600 border-r border-gray-200">
                <img src={raised} alt="Truck Icon" className="w-5 h-5" />
                <div className="text-center">
                  <div
                    className="underline cursor-pointer text-xs"
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/nfa_raised_report",
                        "NFA Raised"
                      )
                    }
                  >
                    NFA Raised
                  </div>
                  <div className="text-black text-sm ">
                    {NFAData?.NFA_Raised || 0}
                  </div>
                </div>
              </div>

              <div className="flex gap-2 items-center p-1 pt-0  text-sm font-semibold text-gray-600">
                <img src={approved} alt="Truck Icon" className="w-5 h-5" />
                <div className="text-center">
                  <div
                    className="underline cursor-pointer text-xs"
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/nfa_approved_report",
                        "NFA Approved but Not Retailed"
                      )
                    }
                  >
                    NFA Approved
                  </div>
                  <div className="text-black text-sm">
                    {NFAData?.NFA_Approved || 0}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid">
              <div className=" p-1 text-sm font-semibold text-gray-600  border-gray-20">
                <div className="text-center">
                  <div
                    className="underline cursor-pointer text-center"
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/nfa_spm",
                        "NFAs approved within recommendation"
                      )
                    }
                  >
                    NFAs approved within recommendation
                  </div>
                  <div className="text-black text-sm">
                    {NFAData?.NFAs_approved_within_recommendation || 0}
                  </div>
                </div>
              </div>
            </div>

            {/* <div className="grid grid-cols-2 gap-2   border-gray-200 ">
              <div className="flex items-center gap-3 p-1  text-sm font-semibold text-gray-600 border-r border-gray-200">
                <img src={mop_growth} alt="Truck Icon" className="w-5 h-5" />
                <div className="text-center">
                  <div
                    className="underline cursor-pointer text-xs"
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/mop_growth_table",
                        "MOP Growth"
                      )
                    }
                  >
                    MOP Growth (₹)
                  </div>
                  <div className="text-black text-sm">
                    {GrowthData?.MOP_Growth || 0}
                  </div>
                </div>
              </div>

              <div className="flex gap-1 items-center p-1   text-sm font-semibold text-gray-600">
                <img src={mop_growth} alt="Truck Icon" className="w-5 h-5" />
                <div className="text-center">
                  <div
                    className="underline cursor-pointer text-xs whitespace-nowrap"
                    onClick={() =>
                      handleOpenModal(
                        "dealer-sales-success-centre/mop_absolute_lob_wise",
                        "MTD MOP Absolute"
                      )
                    }
                  >
                    MTD MOP Absolute (₹)
                  </div>
                  <div className="text-black text-sm">
                    {GrowthData?.MOP_Absolute || 0}
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </>
      )}

      {isModalOpen && (
        <ModalMuiTable
          open={isModalOpen}
          heading={modalHeading}
          apiEndpoint={modalApi}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default DseLowPipeline;
